<template>
    <div v-show="visible">
        <el-dialog title="必须打卡日期" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="400px"> 
             日期
            <el-date-picker style="width:140px;"
                v-model="form.date"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd">
            </el-date-picker> 
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span> 
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http'; 
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible:false,
                form:{
                    name:"",
                    date:""
                },
                radio:"",
                data:[],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(){
                this.visible=true;
                this.form.date="";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                if(this.$util.isEmpty(this.form.date)){
                    this.$commonFn.showTip('日期不可为空',3);
                    return;
                }
                let specialDate={};
                specialDate.date=this.form.date;
                specialDate.flag=2;
                this.$parent.addDate(specialDate);
                this.visible=false;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/attendance/group/AddDate.vue